import React, { createContext, useContext } from 'react'

const defaultValue = {
  pendingCount: 0,
  defaultSuppliersCount: 0,
  refreshCounts: () => {},
}

export const SupplierInvitesCountsContext = createContext(defaultValue)

export function useSupplierInvitesCounts() {
  return useContext(SupplierInvitesCountsContext)
}

export function SupplierInvitesCountsProvider({ value, children }) {
  return (
    <SupplierInvitesCountsContext.Provider value={value}>
      {children}
    </SupplierInvitesCountsContext.Provider>
  )
}
